<template>
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.12328 23.604H19.0753C21.1473 23.604 22.8353 21.92 22.8353 19.844V4.15203C22.8353 2.08003 21.1513 0.392029 19.0753 0.392029H4.12328C2.05128 0.392029 0.363281 2.07603 0.363281 4.15203V6.72803C0.363281 7.16803 0.723281 7.52803 1.16328 7.52803C1.60328 7.52803 1.96328 7.16803 1.96328 6.72803V4.15203C1.96328 2.96403 2.93128 1.99203 4.12328 1.99203H19.0753C20.2633 1.99203 21.2353 2.96003 21.2353 4.15203V19.844C21.2353 21.032 20.2673 22.004 19.0753 22.004H4.12328C2.93528 22.004 1.96328 21.036 1.96328 19.844V17.176C1.96328 16.736 1.60328 16.376 1.16328 16.376C0.723281 16.376 0.363281 16.736 0.363281 17.176V19.844C0.367281 21.92 2.05128 23.604 4.12328 23.604Z"
      fill="#FFC436"
    />
    <path
      d="M0.367188 12.0001C0.367188 12.4401 0.727187 12.8001 1.16719 12.8001H13.6312L9.85519 16.5761C9.54319 16.8881 9.54319 17.3961 9.85519 17.7081C10.0112 17.8641 10.2152 17.9441 10.4192 17.9441C10.6232 17.9441 10.8272 17.8641 10.9832 17.7081L15.9432 12.7481C16.2552 12.4361 16.2552 11.9281 15.9432 11.6161L10.9832 6.65606C10.6712 6.34406 10.1632 6.34406 9.85119 6.65606C9.53919 6.96806 9.53919 7.47606 9.85119 7.78806L13.2632 11.2001H1.16719C0.723188 11.2001 0.367188 11.5601 0.367188 12.0001Z"
      fill="#FFC436"
    />
  </svg>
</template>

<script>
export default {
  name: "LogoutIcon",
};
</script>
